import { RecentActivityLog } from './RecentActivityLog';
import { Skeleton } from '@/components/ui/skeleton';

const RecentActivity = ({ activityData }) => {

    console.log("activityData", activityData);
    const isLoading = activityData === null || activityData === undefined;

    return (
        <>
            <div className='flex flex-wrap mb-5 w-full'>
                <div className="card w-full">
                    <div className="card-header px-3.5">
                        <h3 className="card-title">Recent Activities</h3>
                    </div>
                    <div className="card-body px-3 pt-4 pb-3 overflow-auto h-[30rem] custom-scrollbar">
                        {isLoading ? (
                            <div className="flex flex-col gap-4 w-full">
                                {[1, 2, 3, 4, 5].map((row) => (
                                    <div key={row} className="flex items-start relative">
                                        <div className="w-9 start-0 top-9 absolute bottom-0 rtl:-translate-x-1/2 translate-x-1/2 border-s border-s-gray-300"></div>
                                        <div className="flex items-center justify-center shrink-0 rounded-full size-9">
                                            <Skeleton className="size-9 rounded-full" />
                                        </div>
                                        <div className="ps-2.5 text-md grow">
                                            <div className="flex flex-col gap-2 mb-2">
                                                <div className="flex items-center gap-3">
                                                    <div className="flex-1 min-w-0 space-y-2">
                                                        <Skeleton className="h-3 w-2/3" />
                                                        <Skeleton className="h-3 w-1/2" />
                                                    </div>
                                                    <Skeleton className="h-5 w-16 rounded-full" />
                                                </div>
                                                <Skeleton className="h-3 w-3/4" />
                                                <div className="flex gap-2">
                                                    <Skeleton className="h-3 w-20" />
                                                    <Skeleton className="h-3 w-28" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <RecentActivityLog activityData={activityData} />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export { RecentActivity }
